import * as React from 'react';
// @ts-expect-error
import Select, {mergeStyles, SelectBaseProps, MultiValueProps} from 'react-select';

import {colors} from '../colors/colors';

// @ts-expect-error
import {ValueComponent, TokenStyle} from '../select-inline/value-component';
import type {FooterButtonProps} from './select-picker-generic';

import {getCustomMenuList} from './custom-menu-list';
import type {ActionMeta} from './select-picker-generic-creatable';
import {selectPickerGenericStyles} from './select-picker-generic-styles';

import styles from '../select-inline/select-inline.module.css';

type Props = SelectBaseProps & {
    value?: any[] | null | undefined;
    options: any[];
    isMulti: boolean;
    valueKey?: string;
    // Matches the size of SelectPickerGeneric
    isSmall?: boolean;
    labelKey?: string;
    hasError?: boolean | null | undefined;
    onClear?: () => void;
    onChange?: (newValue: any, actionMeta: ActionMeta) => void;
    tokenizedStyle?: TokenStyle;
    footerButton?: FooterButtonProps;
    menuZIndex?: number;
};

export function SelectPickerGenericMulti(props: Props) {
    const {styles, hasError, onClear, onChange, footerButton, ...restProps} = props;

    const componentStyles = {
        // @ts-expect-error
        input: (base) => ({
            ...base,
            padding: 0,
            marginBottom: props.isSmall ? 0 : 6,
        }),
        // @ts-expect-error
        control: (base, state) => {
            let controlStyles = {
                ...base,
                border: hasError ? `1px solid ${colors.rose}` : `1px solid ${colors.offWhiteDk}`,
                paddingTop: props.isSmall ? '0' : '5px',
                height: 'unset',
            };

            if (state.isDisabled || props.isDisabled) {
                controlStyles = {
                    ...controlStyles,
                    color: 'var(--grey-lt)',
                    backgroundColor: 'var(--off-white)',
                    opacity: 0.6,
                };
            }

            return controlStyles;
        },
        // @ts-expect-error
        indicatorsContainer: (base) => ({
            ...base,
            marginTop: props.isSmall ? 0 : -5,
        }),
        // @ts-expect-error
        placeholder: (base) => ({
            ...base,
            marginTop: props.isSmall ? 0 : -3,
            color: base.color,
            transition: 'color 200ms linear',
        }),
        // @ts-expect-error
        indicatorSeparator: (base, state) => ({
            ...base,
            display: onClear && state.hasValue ? undefined : 'none',
        }),
        // @ts-expect-error
        multiValueRemove: (base) => ({
            ...base,
            '&:hover': {
                backgroundColor: '#e6e6e6;',
                color: 'black',
            },
        }),
        // @ts-expect-error
        menu: (base) => {
            let menuStyles = {
                ...base,
            };

            if (props.menuZIndex) {
                menuStyles = {
                    ...menuStyles,
                    zIndex: props.menuZIndex,
                };
            }

            return menuStyles;
        },
        ...(footerButton && {
            // @ts-expect-error
            menuList: (base) => ({
                ...base,
                paddingBottom: 42,
            }),
        }),
    } as const;

    let mergedStyles = mergeStyles(selectPickerGenericStyles, componentStyles);

    // Add in styles from props
    if (styles) {
        mergedStyles = mergeStyles(mergedStyles, styles);
    }

    // @ts-expect-error
    const handleChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'clear' || newValue === null || typeof newValue === 'undefined') {
            if (onClear) {
                onClear();
            }
        } else if (onChange) {
            onChange(newValue, actionMeta);
        }
    };

    const getMultiValueComponent = (propsFromReactSelect: MultiValueProps) => {
        return (
            <div className={props.isSmall ? 'pt-4' : ''}>
                <ValueComponent
                    data={propsFromReactSelect.data}
                    labelKey={props.labelKey || 'label'}
                    valueKey={props.valueKey || 'value'}
                    tokenizedStyle={props.tokenizedStyle || 'light'}
                    onRemove={propsFromReactSelect.removeProps.onClick}
                />
            </div>
        );
    };

    return (
        <Select
            {...restProps}
            isMulti={true}
            onChange={handleChange}
            styles={mergedStyles}
            components={{
                MultiValue: getMultiValueComponent,
                MenuList: getCustomMenuList(footerButton),
            }}
        />
    );
}
